<!-- .block-slideshow -->
<div class="block-slideshow   {{fullWidth? 'w-full-container':''}}">
    <div>
        <div class="row">
            <div *ngIf="withDepartments" class="col-3 d-lg-block d-none" appDepartmentsArea></div>
            <div class="col-12" [ngClass]="{'col-lg-12': !withDepartments, 'col-lg-9': withDepartments}">
                <div class="block-slideshow__body">
                    <owl-carousel-o *ngIf="bannerItems?.length" [options]="options" appOwlPreventClick>
                        <ng-template *ngFor="let item of bannerItems" carouselSlide>
                            <div>
                                <a class="block-slideshow__slide" *ngIf="!item.external" [routerLink]="item.url" appClick>
                                    <div class="block-slideshow__slide-image" *ngIf="item.images && item.images[translate.currentLang]?.url"><img [src]="item.images[translate.currentLang]?.url" [alt]="item.name" /></div>
                                </a>
                                <a class="block-slideshow__slide" *ngIf="item.external" [href]="item.url" appClick>
                                    <div class="block-slideshow__slide-image" *ngIf="item.images && item.images[translate.currentLang]?.url"><img [src]="item.images[translate.currentLang]?.url" [alt]="item.name" /></div>
                                </a>
                            </div>
                        </ng-template>
                    </owl-carousel-o>
                    <owl-carousel-o *ngIf="element?.images" [options]="options" appOwlPreventClick>
                        <ng-template *ngFor="let item of element?.images | keyvalue; let i = index" carouselSlide>
                            <div>
                                <div class="block-slideshow__slide">
                                    <div class="element block-slideshow__slide-image"><img [src]="item.value.url" [alt]="element.name.en+'_'+i" /></div>
                                </div>

                            </div>
                        </ng-template>
                    </owl-carousel-o>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- .block-slideshow / end -->